import { render } from "@/components/pages/individualWorkSupport/requirement094/Requirement094.html?vue&type=template&id=4ef89c3a&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement094/Requirement094.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement094/Requirement094.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement094/Requirement094.scss?vue&type=style&index=0&id=4ef89c3a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef89c3a"]])

export default __exports__